export const Config = {
  awsRegion: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_loMAlvRxu',
  cognitoClientId: '4sv4u8lg8ko31qpbccqdlfc1ep',
  cognitoIdentityPoolId: 'us-east-1:f4871d2e-37db-4d5f-925e-6379208c74c3',
  dynamoDbTables: {
    TRANSACTION_TABLE: 'jashsoft-transactions'
  },
  stripePublishableKey: 'pk_qjd1X8V0djlDIBcAruc8fjbSFfUU8'
};
